
export const DISPUTE_TYPES = [
  { value: "already-refunded", label: "Already Refunded" },
  { value: "cancelled-merchandise-or-service", label: "Cancelled Merchandise or Service" },
  { value: "cancelled-recurring", label: "Cancelled Recurring" },
  { value: "credit-not-processed", label: "Credit Not Processed" },
  { value: "did-not-receive", label: "Did Not Receive" },
  { value: "duplicate-processing", label: "Duplicate Processing" },
  { value: "generic", label: "Generic" },
  { value: "fraud", label: "Fraud" },
  { value: "misrepresentation", label: "Misrepresentation" },
  { value: "not-as-described-or-defective", label: "Not as Described or Defective" },
  { value: "partial-refund", label: "Partial Refund" },
  { value: "past-rc-timeframe-to-file", label: "Past RC Timeframe to File" },
  { value: "pnot-already-refunded", label: "PNOT Already Refunded" },
  { value: "rr-already-refunded", label: "RR Already Refunded" },
]

// const operatorsMap = [
//   { orig: "exists", mapsTo: "mustExist" },
//   { orig: "unexists", mapsTo: "mustNotExist" },
//   { orig: "eq", mapsTo: "mustBe" },
//   { orig: "neq", mapsTo: "mustBeNot" },
//   { orig: "stricteq", mapsTo: "mustBeStrict" },
//   { orig: "strictneq", mapsTo: "mustNotBeStrict" },
//   { orig: "includes", mapsTo: "mustContain" },   // subject (api value) includes target (value sought)
//   { orig: "notincludes", mapsTo: "mustNotContain" },
//   { orig: "contains", mapsTo: "mustInclude" },    // subject (api value) must be a member of the target value
//   { orig: "notcontains", mapsTo: "mustNotInclude" },
// ]

export const OPERATORS = [
  { label: "Must Equal", value: "mustBe", inputType: "text", symbol: "=", requiresValue: true, def: "", orig: "eq" },
  { label: "Must Not Equal", value: "mustBeNot", inputType: "text", symbol: "≠", requiresValue: true, def: "", orig: "neq" },
  { label: "Must Strictly Equal", value: "mustBeStrict", inputType: "text", symbol: "===", requiresValue: true, def: "", orig: "stricteq" },
  { label: "Must Strictly Not Equal", value: "mustNotBeStrict", inputType: "text", symbol: "≠", requiresValue: true, def: "", orig: "strictneq" },
  { label: "Must Equal One Of", value: "mustBeOr", inputType: "text", symbol: "∈", requiresValue: true, def: "" },
  { label: "Must Include One Of", value: "mustInclude", inputType: "text", symbol: "⊇", requiresValue: true, def: "", orig: "contains" },
  { label: "Must Not Include Any Of", value: "mustNotInclude", inputType: "text", symbol: "⊈", requiresValue: true, def: "", orig: "notcontains" },
  { label: "Must Be Greater Than", value: "mustBeGt", inputType: "number", symbol: ">", requiresValue: true, def: "" },
  { label: "Must Be Greater Than or Equal To", value: "mustBeGte", inputType: "number", symbol: "≥", requiresValue: true, def: "" },
  { label: "Must Be Less Than", value: "mustBeLt", inputType: "number", symbol: "<", requiresValue: true, def: "" },
  { label: "Must Be Less Than or Equal To", value: "mustBeLte", inputType: "number", symbol: "≤", requiresValue: true, def: "" },
  { label: "Must Be Before", value: "mustBeBefore", inputType: "date", symbol: "≺", requiresValue: true, def: "" },
  { label: "Must Be After", value: "mustBeAfter", inputType: "date", symbol: "≻", requiresValue: true, def: "" },
  { label: "Must Exist", value: "mustExist", inputType: "text", symbol: "∃", requiresValue: false, def: "", orig: "exists" },
  { label: "Must Not Exist", value: "mustNotExist", inputType: "text", symbol: "∄", requiresValue: false, def: "", orig: "unexists" },
  { label: "Must Have Object With", value: "hasObjectWhere", inputType: "text", symbol: "∈", requiresValue: true, def: "" },
  { label: "Must Not Have Object With", value: "hasNoObjectWhere", inputType: "text", symbol: "∈", requiresValue: true, def: "" },
]

interface IConversion {
  label:string 
  value:string
  method:(data:any) => any
}

const handleArrayConversion = (data:any[], conversion:string, value?:any) => {
  if( conversion === "getCount" ) {
    return data && data.length ? data?.length : 0
  }

  if( conversion === "getFirst" ) {
    if( !value.includes(":") ){
      return data ? data?.[0] : null
    } else {
      const [ key, val ] = value.split(":")
      const found = data ? data?.[0] : null
      if( !found ) return null
      const obj = found[key]
      return obj
      // console.log(obj)
      // if( obj.includes(value) ) {
      //   return true
      // } else {
      //   return false
      // }
    }
  }

  if( conversion === "getLast" ) {

    return data && data.length ? data?.[data.length - 1] : null
  }
}

export const CONVERSIONS:IConversion[] = [
  { label: "None", value: "none", method: (data:any, value?:any) => data },
  { label: "Convert To String", value: "toString", method: (data:any, value?:any) => data.toString() },
  { label: "Convert To Number", value: "toNumber", method: (data:any, value?:any) => parseFloat(data) },
  { label: "Convert To Date", value: "toDate", method: (data:any, value?:any) => new Date(data) },
  { label: "Convert To Boolean", value: "toBoolean", method: (data:any) => !!data },
  { label: "Get Number of Items", value: "getCount", method: (data:any[], value?:any) => handleArrayConversion(data, "getCount", value) },
  { label: "Get First Item", value: "getFirst", method: (data:any[], value?:any) => handleArrayConversion(data, "getFirst", value) },
  { label: "Get Last Item", value: "getLast", method: (data:any[], value?:any) => handleArrayConversion(data, "getLast", value) }
]


export const RULES_ACTIONS = [
  { label: "Convert", value: "convert" },
  { label: "Format", value: "format" },
  { label: "Hide", value: "hide" },
  { label: "Replace", value: "replace" },
  { label: "Re-Order", value: "reorder" }
]


export const ELEMENTS = [
  { 
    refstr: "topbar",
    title: "Topbar",
    description: "Typically displays the Merchant Reference and Case ID. Not editable for now.",
    links: [],
    config: { structure: [] }
  },
  { 
    refstr: "title_block",
    title: "Title Area",
    description: "Will almost always display the title 'Dispute Evidence'.",
    links: [],
    config: { structure: [] }
  },
  { 
    refstr: "mm_logo",
    title: "Logo Area",
    description: "Displays the Midmetrics logo.",
    links: [],
    config: { structure: [] }
  },
  { 
    refstr: "summary_block",
    title: "Summary Block",
    description: "Displays a quick summary of the Chargeback Amount and Reason Code info.",
    links: [],
    config: { structure: [] }
  },
  { 
    refstr: "summary_table",
    title: "Summary Table",
    description: "Displays a vertical table of key chargeback data.",
    config: {
      alsouseRules: [
        { label: "**Entire Summary Table", value: "component"}
      ],
      structure: [
        { order: 1, refstr: "MID", label: "MID", path: "merchant.AccountNumber", useRules: true },
        { order: 2, refstr: "merchantname", label: "Merchant Name", path: "merchant.DBA", useRules: true },
        { order: 3, refstr: "caseid", label: "Case ID", path: "rp.Chargeback.ProcessorCaseId", useRules: true },
        { order: 4, refstr: "trxid", label: "Transaction ID", path: "rp.Chargeback.ExternalChargebackId", useRules: true },
        { order: 5, refstr: "ARN", label: "ARN/REF", path: "rp.Chargeback.ARN", useRules: true },
        { order: 6, refstr: "chargebackDate", label: "Chargeback Date", path: "rp.Chargeback.DisputeDate", useRules: true },
        { order: 7, refstr: "chargebackAmt", label: "Chargeback Amount", path: "rp.Chargeback.Amount", useRules: true },
        { order: 8, refstr: "BIN", label: "BIN", path: "rp.Chargeback.BIN", useRules: true },
        { order: 9, refstr: "lastfour", label: "Last Four", path: "rp.Chargeback.LastFour", useRules: true },
        { order: 10, refstr: "trxdate", label: "Transaction Date", path: "rp.RepresentmentTransactionInfo.TransactionDate", useRules: true },
        { order: 11, refstr: "trxamt", label: "Transaction Amount", path: "rp.RepresentmentTransactionInfo.Amount", useRules: true },
      ]
    },
    links: []
  },
  { 
    refstr: "letter_prefix",
    title: "Letter Prefix",
    description: "Displays the opening lines to the dispute letter. Will be customizable very soon.",
    links: [],
    config: { structure: [] }
  },
  { 
    refstr: "opening_statements",
    title: "Opening Statements",
    description: "Generate powerful, easy-to-manage conditional queries and statements.",
    links: [
      { type: "refstr-link", label: "Open the Editing Tool", path: "/dispute/xxxx/element?elem=opening_statements&op=list" },
    ],
    config: { structure: [] }
  },
  { 
    refstr: "trx_history",
    title: "Trx History Table",
    description: "Displays the Trx History Table. Will have some customization features very soon.",
    links: [],
    config: {
      allowedTypes: [ "sale", "refund", "capture" ],
      alsouseRules: [
        { label: "**Entire Trx History Table", value: "component"}
      ],
      structure: [
        { order: 1, label: "Trx Date", refstr: "trxdate", path: "rp.AdditionalTransactions[idx].TransactionDetails.TransactionDate", format: "date", useRules: true },
        { order: 2, label: "Amount", refstr: "amt", path: "rp.AdditionalTransactions[idx].TransactionDetails.Amount", format: "currency", useRules: true },
        { order: 3, label: "BIN", refstr: "BIN", path: "rp.AdditionalTransactions[idx].TransactionDetails.BIN", useRules: true },
        { order: 4, label: "Last Four", refstr: "lastfour", path: "rp.AdditionalTransactions[idx].TransactionDetails.LastFour", useRules: true },
        { order: 5, label: "Customer Name", refstr: "customername", path: "rp.AdditionalTransactions[idx].TransactionDetails.ConsumerName", useRules: true },
        { order: 6, label: "Merch Ref", refstr: "merchantref", path: "rp.AdditionalTransactions[idx].TransactionDetails.MerchantReference", useRules: true },
        { order: 7, label: "Type", refstr: "actiontype", path: "rp.AdditionalTransactions[idx].TransactionDetails.ActionType", useRules: true },
        { order: 8, label: "Trx Id", refstr: "trxid", path: "rp.AdditionalTransactions[idx].TransactionDetails.ExternalTransactionId", useRules: true },
        { order: 9, label: "AuthCode", refstr: "authcode", path: "rp.AdditionalTransactions[idx].TransactionDetails.AuthorizationCode", useRules: true }
      ]
    },
  },
  { 
    refstr: "pkg_tracking",
    title: "Package Tracking",
    description: "Displays package tracking information when available.",
    links: [],
    config: { structure: [] }
  },
  { 
    refstr: "supporting_images",
    title: "Supporting Images",
    description: "Displays supporting images for the dispute. This will be highly editable very soon.",
    links: [],
    config: { structure: [] }
  },
  { 
    refstr: "cs_notes",
    title: "Customer Service Notes",
    description: "Displays notes from Customer Service contact when available.",
    links: [],
    config: { structure: [] }
  },
  { 
    refstr: "compelling_evidence",
    title: "Compelling Evidence",
    description: "Very similar to Opening Statements, where you can craft dynamic, query-based statements.",
    links: [
      { type: "refstr-link", label: "Open the Editing Tool", path: "/dispute/xxxx/element?elem=compelling_evidence&op=list" },
    ],
    config: { structure: [] }
  },
  { 
    refstr: "detail_screens",
    title: "Detail Screens",
    description: "Displays pre-formatted detail screens based on Trx History data.",
    links: [],
    config: {
      sections: [
        { refstr: "trxinfo", label: "Transaction Information" },
        { refstr: "ccinfo", label: "Credit Card Information" },
        { refstr: "customerinfo", label: "Customer Information" },
        { refstr: "actionsinfo", label: "Actions" }
      ],
      structure: [
        { section: "trxinfo", label: "Merchant", refstr: "merchant", path: "rp.RepresentmentTransactionInfo.MerchantName", useRules: true },
        { section: "trxinfo", label: "Transaction ID", refstr: "trxid", path: "rp.RepresentmentTransactionInfo.MerchantName", useRules: true },
        { section: "trxinfo", label: "Entry Method", refstr: "entrymethod", path: "rp.RepresentmentTransactionInfo.MerchantName", useRules: true },
        { section: "trxinfo", label: "Response Code", refstr: "respcode", path: "rp.RepresentmentTransactionInfo.MerchantName", useRules: true },
        { section: "trxinfo", label: "Date", refstr: "trxdate", path: "rp.RepresentmentTransactionInfo.MerchantName", useRules: true },
        { section: "trxinfo", label: "Transaction Type", refstr: "trxtype", path: "rp.RepresentmentTransactionInfo.MerchantName", useRules: true },
        { section: "trxinfo", label: "Transaction Amount", refstr: "trxamt", path: "rp.RepresentmentTransactionInfo.MerchantName", useRules: true },
        { section: "trxinfo", label: "Status", refstr: "trxstatus", path: "rp.RepresentmentTransactionInfo.MerchantName", useRules: true },

        { section: "ccinfo", label: "CC Number", refstr: "ccnumber", path: "rp.RepresentmentTransactionInfo.MerchantName", useRules: true },
        { section: "ccinfo", label: "CC Type", refstr: "cctype", path: "rp.RepresentmentTransactionInfo.MerchantName", useRules: true },
        { section: "ccinfo", label: "CVV Status", refstr: "cvv", path: "rp.RepresentmentTransactionInfo.MerchantName", useRules: true },
        { section: "ccinfo", label: "CC Expiration", refstr: "ccexp", path: "rp.RepresentmentTransactionInfo.MerchantName", useRules: true },
        { section: "ccinfo", label: "AVS Status", refstr: "avs", path: "rp.RepresentmentTransactionInfo.MerchantName", useRules: true },
        { section: "ccinfo", label: "Auth Code", refstr: "authcode", path: "rp.RepresentmentTransactionInfo.MerchantName", useRules: true },

        { section: "customerinfo", label: null, refstr: "billname", path: "rp.RepresentmentTransactionInfo.ConsumerName", useRules: true },
        { section: "customerinfo", label: null, refstr: "billaddr", path: "rp.RepresentmentTransactionInfo.ConsumerAddress", useRules: true },
        { section: "customerinfo", label: null, refstr: "billcity", path: "rp.RepresentmentTransactionInfo.ConsumerCity", useRules: true },
        { section: "customerinfo", label: null, refstr: "billstate", path: "rp.RepresentmentTransactionInfo.ConsumerState", useRules: true },
        { section: "customerinfo", label: null, refstr: "billzip", path: "rp.RepresentmentTransactionInfo.ConsumerZipCode", useRules: true },
        { section: "customerinfo", label: null, refstr: "billcountry", path: "rp.RepresentmentTransactionInfo.ConsumerCountry", useRules: true },
        { section: "customerinfo", label: null, refstr: "billphone", path: "rp.RepresentmentTransactionInfo.ConsumerCountry", useRules: true },
        
        { section: "customerinfo", label: null, refstr: "shipname", path: "rp.RepresentmentTransactionInfo.ConsumerName", useRules: true },
        { section: "customerinfo", label: null, refstr: "shipaddr", path: "rp.RepresentmentTransactionInfo.ConsumerAddress", useRules: true },
        { section: "customerinfo", label: null, refstr: "shipcity", path: "rp.RepresentmentTransactionInfo.ConsumerCity", useRules: true },
        { section: "customerinfo", label: null, refstr: "shipstate", path: "rp.RepresentmentTransactionInfo.ConsumerState", useRules: true },
        { section: "customerinfo", label: null, refstr: "shipzip", path: "rp.RepresentmentTransactionInfo.ConsumerZipCode", useRules: true },
        { section: "customerinfo", label: null, refstr: "shipcountry", path: "rp.RepresentmentTransactionInfo.ConsumerCountry", useRules: true },
        { section: "customerinfo", label: null, refstr: "shipphone", path: "rp.RepresentmentTransactionInfo.ConsumerCountry", useRules: true },

        { section: "actionsinfo", label: null, refstr: "actiontype", path: "xxxxxx", useRules: true },
        { section: "actionsinfo", label: null, refstr: "actiondate", path: "xxxxxx", useRules: true },
        { section: "actionsinfo", label: null, refstr: "actionamt", path: "xxxxxx", useRules: true },
        { section: "actionsinfo", label: null, refstr: "actioncurrency", path: "xxxxxx", useRules: true },
      ] 
    }
  },
  { 
    refstr: "policies",
    title: "Policies",
    description: "Displays any policies made available by the merchant.",
    links: [],
    config: { structure: [] }
  },
  { 
    refstr: "letter_closing",
    title: "Letter Closing",
    description: "The letter closing area, typically very brief.",
    links: [],
    config: { structure: [] }
  },
  { 
    refstr: "disclaimer",
    title: "Disclaimer",
    description: "Usually displays standard disclaimer for the bottom of each template.",
    links: [],
    config: { structure: [] }
  }
]



/*
{ 
    refstr: "detail_screens",
    title: "Detail Screens",
    description: "Displays pre-formatted detail screens based on Trx History data.",
    links: [],
    config: { 
      structure: [
        {
          order: 1,
          type: "full",
          block: "trx_info",
          label: "Transaction Information",
          columns: [
            [
              { label: "Merchant", refstr: "merchant", path: "rp.RepresentmentTransactionInfo.MerchantName", useRules: true },
              { label: "Transaction ID", refstr: "trxid", path: "rp.RepresentmentTransactionInfo.MerchantName", useRules: true },
              { label: "Entry Method", refstr: "entrymethod", path: "rp.RepresentmentTransactionInfo.MerchantName", useRules: true },
              { label: "Response Code", refstr: "respcode", path: "rp.RepresentmentTransactionInfo.MerchantName", useRules: true },
            ],
            [
              { label: "Date", refstr: "trxdate", path: "rp.RepresentmentTransactionInfo.MerchantName", useRules: true },
              { label: "Transaction Type", refstr: "trxtype", path: "rp.RepresentmentTransactionInfo.MerchantName", useRules: true },
              { label: "Transaction Amount", refstr: "trxamt", path: "rp.RepresentmentTransactionInfo.MerchantName", useRules: true },
              { label: "Status", refstr: "trxstatus", path: "rp.RepresentmentTransactionInfo.MerchantName", useRules: true },
            ]
          ]
        },
        {
          order: 2,
          type: "full",
          block: "cc_info",
          label: "Credit Card Information",
          columns: [
            [
              { label: "CC Number", refstr: "ccnumber", path: "rp.RepresentmentTransactionInfo.MerchantName", useRules: true },
              { label: "CC Type", refstr: "cctype", path: "rp.RepresentmentTransactionInfo.MerchantName", useRules: true },
              { label: "CVV Status", refstr: "cvv", path: "rp.RepresentmentTransactionInfo.MerchantName", useRules: true },
            ],
            [
              { label: "CC Expiration", refstr: "ccexp", path: "rp.RepresentmentTransactionInfo.MerchantName", useRules: true },
              { label: "AVS Status", refstr: "avs", path: "rp.RepresentmentTransactionInfo.MerchantName", useRules: true },
              { label: "Auth Code", refstr: "authcode", path: "rp.RepresentmentTransactionInfo.MerchantName", useRules: true },
            ]
          ]
        },
        {
          order: 3,
          type: "half",
          block: "billing_info",
          labek: "Billing Information",
          columns: [
            { label: null, refstr: "billname", path: "rp.RepresentmentTransactionInfo.ConsumerName", useRules: true },
            { label: null, refstr: "billaddr", path: "rp.RepresentmentTransactionInfo.ConsumerAddress", useRules: true },
            { label: null, refstr: "billcity", path: "rp.RepresentmentTransactionInfo.ConsumerCity", useRules: true },
            { label: null, refstr: "billstate", path: "rp.RepresentmentTransactionInfo.ConsumerState", useRules: true },
            { label: null, refstr: "billzip", path: "rp.RepresentmentTransactionInfo.ConsumerZipCode", useRules: true },
            { label: null, refstr: "billcountry", path: "rp.RepresentmentTransactionInfo.ConsumerCountry", useRules: true },
            { label: null, refstr: "billphone", path: "rp.RepresentmentTransactionInfo.ConsumerCountry", useRules: true }
          ]
        },
        {
          order: 4,
          type: "half",
          block: "shipping_info",
          labek: "Shipping Information",
          columns: [
            { label: null, refstr: "shipname", path: "rp.RepresentmentTransactionInfo.ConsumerName", useRules: true },
            { label: null, refstr: "shipaddr", path: "rp.RepresentmentTransactionInfo.ConsumerAddress", useRules: true },
            { label: null, refstr: "shipcity", path: "rp.RepresentmentTransactionInfo.ConsumerCity", useRules: true },
            { label: null, refstr: "shipstate", path: "rp.RepresentmentTransactionInfo.ConsumerState", useRules: true },
            { label: null, refstr: "shipzip", path: "rp.RepresentmentTransactionInfo.ConsumerZipCode", useRules: true },
            { label: null, refstr: "shipcountry", path: "rp.RepresentmentTransactionInfo.ConsumerCountry", useRules: true },
            { label: null, refstr: "shipphone", path: "rp.RepresentmentTransactionInfo.ConsumerCountry", useRules: true }
          ]
        }

      ] 
    }
  },
*/